export enum PharmacistRoles {
  PHARMACIST = 'Pharmacist',
}
